export async function searchVideos(query) {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/videos/search?query=${query}`,
    )
    if (!res.ok) {
      return []
    }
    const result = await res.json()
    return result.data || []  // ✅ return only the data array
  } catch (error) {
    return []
  }
}